import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';
import { PATH_ROUTES } from 'routes/path';
import AIGeneratingImage from 'assets/images/ai_report_generating.png';
import LabGeneratingImage from 'assets/images/lab_report_generating.png';
import { cn } from 'lib/utils';

export default function ReportGenerating({
  isDetails = false,
  reportType = 'ai',
}: {
  isDetails?: boolean;
  reportType?: 'lab' | 'ai';
}) {
  console.log('🚀 ~ ReportGenerating ~ reportType:', reportType);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isLabReport = reportType === 'lab';
  console.log('🚀 ~ ReportGenerating ~ isLabReport:', isLabReport);

  return (
    <div className='lg:h-[calc(100vh-8rem)] flex items-center justify-center flex-col max-w-5xl mx-auto py-8'>
      <div className='flex flex-col items-center justify-center space-y-4 md:space-y-8'>
        <img
          src={isLabReport ? LabGeneratingImage : AIGeneratingImage}
          alt='generating'
          className='object-contain w-full h-60'
        />
        <div
          className={cn(
            'w-full px-4 space-y-4 text-center md:w-1/2',
            !isLabReport && 'md:w-full'
          )}
        >
          <h2 className='text-base font-semibold whitespace-pre md:text-lg'>
            {isLabReport
              ? t('generating_lab_title')
              : t('generating_personalised_title')}
          </h2>
          <p className='text-sm font-medium md:text-base'>
            {isLabReport
              ? t('generating_lab_info')
              : t('generating_personalised_info')}
          </p>
        </div>
        {!isDetails ? (
          <Button
            className='px-6 text-sm h-9 md:text-base'
            onClick={() => {
              navigate(PATH_ROUTES.PERSONALISED_AI_REPORT);
            }}
          >
            {t('go_to_reports')}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
